export default {
    url: '/target',
    template: `
        <div class="loader02" ng-if="!vm.course"></div>
        <courses-courses-edit-target
            course="vm.course"
            departments="vm.departments"
            roles="vm.roles"
            levels="vm.levels"
            can-manage-course="vm.canManageCourse"
        />`,
    resolve: {
        course ($stateParams, CourseResource, CourseService) {
            return CourseResource.get({
                id: $stateParams.id,
                expand: 'fields,courseFields,courseTrainings,courseTrainings.scormTrainings,courseTargetsWithValue.employee.drlsWithValue,activeI18n,' +
                    'courseI18ns,courseTrainingI18ns,courseVersions,courseTrainingForms,sites,planningGroups.planningGroupTargets,courseTrainings.materials,' +
                    'courseTrainings.materials.languages,courseTrainings.materials.chapters.chapterI18ns,' +
                    'courseTrainings.materials.chapters.section.sectionI18ns'
            }).$promise.then((course) => {
                CourseService.nestCompositeModels(course);
                return course;
            });
        }
    },
    controller ($scope, CLASSIFIER_ENUM, course, classifiers, CourseService) {
        $scope.$parent.vm.step = 2;
        $scope.$parent.vm.course = course;
        $scope.$parent.vm.isArchived = course.isArchived;
        this.course = angular.copy(course);
        this.canManageCourse = CourseService.canManageCourse(course);
        // we delete the following key because it is not needed for target tab
        delete this.course.courseVersions;
        this.departments = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.LEVEL);

        $scope.$on('archiveChange', (event, { isArchived }) => {
            $scope.$parent.vm.isArchived = isArchived;
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/target/index.js